import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ProductErrors } from '@infrab4a/connect';
import { MessageService } from 'primeng/api';
import { firstValueFrom } from 'rxjs';
import { TableColumn } from 'src/app/components/table';
import {
  HooklabGroup,
  HooklabService
} from 'src/app/connect-api/api/shop/hooklab.service';
import { ShopProductErrorsService } from 'src/app/connect-api/api/shop/shop-product-errors.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-product-errors',
  templateUrl: './product-errors.component.html',
  styleUrl: './product-errors.component.scss'
})
export class ProductErrorsComponent implements OnInit {
  private title = inject(Title);
  protected productErrorsService = inject(ShopProductErrorsService);
  private hooklabService = inject(HooklabService);
  private messageService = inject(MessageService);

  cols = [
    new TableColumn.Builder()
      .setHeader('ID')
      .setField('product.id')
      .setRouterLink('/shop-products/catalog/product/')
      .setRouterLinkFieldName('getProductId')
      .setCondition('equals')
      .build(),
    new TableColumn.Builder()
      .setHeader('Nome')
      .setField('product.name')
      .setRouterLink('/shop-products/catalog/product/')
      .setRouterLinkFieldName('getProductId')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Grupo')
      .setField('product.group')
      .setType('text')
      .setSortable(false)
      .setCondition('equals')
      .setDisplayFunction((error: ProductErrors) => {
        if (!error.product?.group) return 'Sem grupo';
        const group = this.groups.find((g) => g.id === error.product.group);
        return group ? group.name : `Grupo ${error.product.group}`;
      })
      .build(),
    new TableColumn.Builder()
      .setHeader('Erros')
      .setField('error')
      .setType('text')
      .setSortable(false)
      .setCondition('equals')
      .build()
  ];

  dropdownFilters: { [field: string]: any[] } = {};
  groups: HooklabGroup[] = [];
  errorDescriptions: string[] = [];

  async ngOnInit() {
    this.title.setTitle('Loja - Erros de Produtos');
    await Promise.all([this.loadGroups(), this.loadErrorDescriptions()]);
  }

  private async loadGroups(): Promise<void> {
    LoaderService.showLoader();

    try {
      const response = await firstValueFrom(this.hooklabService.getGroups());
      this.groups = response.data || [];

      this.dropdownFilters['product.group'] = [
        { label: 'Todos', value: null },
        ...this.groups.map((group) => ({
          label: group.name,
          value: group.id
        }))
      ];
    } catch (error) {
      console.error('Erro ao carregar grupos:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail:
          'Erro ao carregar grupos do Hooklab. Os grupos padrão serão usados.'
      });
    } finally {
      LoaderService.showLoader(false);
    }
  }

  private async loadErrorDescriptions(): Promise<void> {
    LoaderService.showLoader();

    try {
      this.errorDescriptions =
        await this.productErrorsService.getProductErrorDescriptions();

      this.dropdownFilters['error'] = [
        { label: 'Todos', value: null },
        ...this.errorDescriptions.map((description) => ({
          label: description,
          value: description
        }))
      ];
    } catch (error) {
      console.error('Erro ao carregar descrições de erros:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro ao carregar as descrições de erros de produtos.'
      });
    } finally {
      LoaderService.showLoader(false);
    }
  }
}
